import { Component, OnInit } from '@angular/core'

@Component({
    selector: './damsnt-overview',
    templateUrl: './damsnt-overview.component.html',
    styleUrls: ['../../../../../help.component.css']
})

export class DAMSNTOverviewComponent implements OnInit {

    ngOnInit() {

    }
}